import React from 'react';
import HeroBanner from '../components/HeroBanner';
import PrincipalMessage from '../components/PrincipalMessage';
import AboutSection from '../components/AboutSection';
import EventsSection from '../components/EventsSection';
import GallerySection from '../components/GallerySection';
import AlumniSection from '../components/AlumniSection';
import PartnersSlider from '../components/PartnersSlider';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { getSchoolStructuredData, getBreadcrumbStructuredData } from '../utils/structuredData';
import { getFAQStructuredData } from '../data/faq';
import './Home.css';

const Home = () => {
  const breadcrumbs = [
    { name: "Home", url: "https://pakschoolandcollege.com/" }
  ];

  return (
    <div className="home-page">
      <SEO
        title="PAK School & College System - Excellence in Education | Home"
        description="PAK School & College System offers quality education with modern facilities, experienced teachers, and comprehensive academic programs. Join us for a bright future. Every Student A Star."
        keywords="PAK School, College, Education, Pakistan, Academic Excellence, Student Development, Quality Education, School Admission, Academic Programs, Every Student A Star"
        url="/"
        image="/assets/hero-banner.jpg"
        structuredData={[
          getSchoolStructuredData(),
          getBreadcrumbStructuredData(breadcrumbs),
          getFAQStructuredData()
        ]}
        canonical="/"
      />
      <HeroBanner />
      <AboutSection />
      <PrincipalMessage />
      <EventsSection />
      <GallerySection />
      <AlumniSection />
      <PartnersSlider />
      <Footer />
    </div>
  );
};

export default Home;
